import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import {isEstimateTab} from '../../components/Page/PageForm';
import {isPromoCode} from "../../components/Cart";

export const sendOrder = createAsyncThunk('order/send', async (captcha, {getState}) => {
  const {project, order} = getState();
  const {orderInformation} = order;
  const {
    projectTypeActive,
    projectTypeActiveHash,
    projectsDetails
  } = project;

  // some hardcore for email tabs change
  ((projectTypeActiveHash === 'templates') && isPromoCode === true) ? isPromoCode = true: isPromoCode = false;

  try {
    return await axios({
      method: 'POST',
      url: projectsDetails[projectTypeActive].endpoint,
      data: {
        projectType: projectsDetails[projectTypeActive].projectName,
        projectHash: projectTypeActiveHash,
        ...orderInformation,
        captcha,
        thankYouPageForce: projectsDetails[projectTypeActive].thankYouPageForce,
        isEstimate: isEstimateTab,
        isPromoCode: isPromoCode
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(response => response && response.data)
  } catch (error) {
    return {
      error: true,
      message: `Internal server error. ${error.message}`
    };
  }
});
